import { render, staticRenderFns } from "./PhotosPicker.vue?vue&type=template&id=c70b1adc&scoped=true"
import script from "./PhotosPicker.vue?vue&type=script&lang=js"
export * from "./PhotosPicker.vue?vue&type=script&lang=js"
import style0 from "./PhotosPicker.vue?vue&type=style&index=0&id=c70b1adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70b1adc",
  null
  
)

export default component.exports